// Libraries
var React = require('react');

// Styles
require('./TimePoint.scss');

class TimePoint extends React.Component {    
	render() {
        return (
            <span className="TimePoint" style={{left: this.props.position}}>
                {this.props.display}
            </span>
		)
	}
}

module.exports = TimePoint;


// WEBPACK FOOTER //
// ./src/components/MDC/Timeline/TimePoint.js